import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ColumnTypeIconModule } from '@y42/column-type';
import { DaterangePickerModule } from '@y42/core/daterange-picker';
import { IntercomModule } from '@y42/intercom';
import { OperationInputAddComponent } from './components/operation-input-add/operation-input-add.component';
import { OperationInputBooleanComponent } from './components/operation-input-boolean/operation-input-boolean.component';
import { OperationInputChipListComponent } from './components/operation-input-chip-list/operation-input-chip-list.component';
import { OperationInputDateTimeFormGroupComponent } from './components/operation-input-date-time/operation-input-date-time-form-group/operation-input-date-time-form-group.component';
import { OperationInputDateTimeComponent } from './components/operation-input-date-time/operation-input-date-time.component';
import { OperationInputDeleteComponent } from './components/operation-input-delete/operation-input-delete.component';
import { OperationInputNumberFormGroupComponent } from './components/operation-input-number/operation-input-number-form-group/operation-input-number-form-group.component';
import { OperationInputNumberComponent } from './components/operation-input-number/operation-input-number.component';
import { OperationInputOperatorFormControlComponent } from './components/operation-input-operator-form-control/operation-input-operator-form-control.component';
import { OperationInputSelectFormGroupComponent } from './components/operation-input-select/operation-input-select-form-group/operation-input-select-form-group.component';
import { OperationInputSelectComponent } from './components/operation-input-select/operation-input-select.component';
import { OperationInputTextFormGroupComponent } from './components/operation-input-text/operation-input-text-form-group/operation-input-text-form-group.component';
import { OperationInputTextComponent } from './components/operation-input-text/operation-input-text.component';
import { OperationInputComponent } from './operation-input.component';

@NgModule({
  exports: [OperationInputComponent],
  declarations: [
    OperationInputComponent,
    OperationInputBooleanComponent,
    OperationInputDateTimeComponent,
    OperationInputNumberComponent,
    OperationInputSelectComponent,
    OperationInputTextComponent,
    OperationInputDateTimeFormGroupComponent,
    OperationInputNumberFormGroupComponent,
    OperationInputTextFormGroupComponent,
    OperationInputOperatorFormControlComponent,
    OperationInputChipListComponent,
    OperationInputSelectFormGroupComponent,
    OperationInputAddComponent,
    OperationInputDeleteComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    MatButtonModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    MatListModule,
    MatInputModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTooltipModule,
    MatAutocompleteModule,

    FontAwesomeModule,
    DaterangePickerModule,

    ColumnTypeIconModule,
    IntercomModule,
  ],
})
export class OperationInputModule {}
